<template>
  <div class="kt-grid kt-grid--ver kt-grid--root kt-page" style="position:relative">
    <div class="kt-grid kt-grid--hor kt-grid--root kt-login kt-login--v1" id="kt_login">
      <div
        class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--desktop kt-grid--ver-desktop kt-grid--hor-tablet-and-mobile"
      >
        <!--begin::Aside-->
        <div
          class="kt-grid__item kt-grid__item--order-tablet-and-mobile-2 kt-grid kt-grid--hor kt-login__aside"
          style="background-image: url(/img/misc/bg-4.jpg);"
        >
          <div class="kt-grid__item">
            <a href="#" class="kt-login__logo">
              <img src="/img/logo-4.png" />
            </a>
          </div>
          <div class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--ver">
            <div class="kt-grid__item kt-grid__item--middle">
              <h3 class="kt-login__title">Welcome to {{$t('WebsiteName')}}!</h3>
              <h4 class="kt-login__subtitle">The ultimate loto management app.</h4>
            </div>
          </div>
          <div class="kt-grid__item">
            <div class="kt-login__info">
              <div class="kt-login__copyright">&copy; {{year}} {{$t('WebsiteName')}}</div>
              <div class="kt-login__menu">
                <a href="#" class="kt-link">{{$t('Privacy')}}</a>
                <a href="#" class="kt-link">{{$t('Legal')}}</a>
                <a href="#" class="kt-link">{{$t('Contact')}}</a>
              </div>
            </div>
          </div>
        </div>
        <!--begin::Aside-->

        <!--begin::Content-->
        <div
          class="kt-grid__item kt-grid__item--fluid kt-grid__item--order-tablet-and-mobile-1 kt-login__wrapper"
          ref="cnt"
        >
          <b-navbar-nav
            class="ml-auto"
            style="display:inline-block;position:absolute;top:10px;right:20px"
          >
            <LanguageDropdown />
          </b-navbar-nav>
          <!--begin::Body-->
          <div class="kt-login__body">
            <!--begin::Signin-->
            <div class="kt-login__form" style="position:relative">
              <div class="kt-login__title">
                <h3>{{$t("Google Authenticator")}}</h3>
              </div>

              <b-alert variant="danger" :show="errShow">{{$t(errMsg)}}</b-alert>

              <!--begin::Form-->
              <form @submit.prevent="onSubmit" class="kt-form" ref="cnt" novalidate="novalidate">
                <input type="hidden" name="token" v-model="token" />
                <div class="form-group">
                  <input v-model="code" type="text" class="form-control" :placeholder="$t('Code')" />
                </div>

                <!--begin::Action-->
                <div class="kt-login__actions">
                  <button
                    type="submit"
                    class="btn btn-primary btn-elevate kt-login__btn-primary"
                  >{{$t("Send Code")}}</button>
                </div>
                <!--end::Action-->
              </form>
              <!--end::Form-->
            </div>
            <!--end::Signin-->
          </div>
          <!--end::Body-->
        </div>
        <!--end::Content-->
      </div>
    </div>
  </div>
</template>

<script>
import LanguageDropdown from "@/containers/LanguageDropdown";
export default {
  name: "TwoFA",
  components: {
    LanguageDropdown
  },
  data() {
    return {
      code: "",
      token: "",
      errShow: false,
      errMsg: "",
      year: new Date().getFullYear()
    };
  },
  created() {
    this.token = this.$route.params.id ? this.$route.params.id : "";
  },
  methods: {
    onSubmit() {
      const loginData = {
        token: this.token,
        code: this.code
      };

      this.errShow = false;
      this.errMsg = "";

      const loader = this.$loading.open({
        container: this.$refs.cnt
      });

      this.$store
        .dispatch("auth/login2fa", loginData)
        .then(resp => {
          this.redirectToHome();
        })
        .catch(err => {
          this.errMsg =
            err.details && err.details.length ? err.details[0] : err.message;
          this.errShow = true;
        })
        .finally(() => {
          loader.close();
        });
    },
    redirectToHome() {
      this.$store.dispatch("auth/me");
      this.$router.push("/home");
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/metronic/theme/login.scss";
</style>
